/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, input, output } from '@angular/core';
import { ControlValueAccessor, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DialogService } from '@shared/component.dialog';
import { DatePickerModalComponent } from './components/date-picker-modal/date-picker-modal.component';
import { formatDate } from '@utils/format-date/format-date';

@Component({
  selector: 'date-picker',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './date-picker.component.html',
  styleUrl: './date-picker.component.scss'
})
export class DatePickerComponent implements ControlValueAccessor {
  placeholder = input<string>('');
  label = input<string>();
  dateSelected = output<string>();
  
  control: FormControl = new FormControl('');

  readonly dialog = inject(DialogService);

  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  writeValue(obj: any): void {
    this.control.setValue(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  openDatePickerModal() {
    const dialogRef = this.dialog.open(DatePickerModalComponent);

    dialogRef.instance().dateSelected.subscribe({
      next: (res: Date) => {
        this.dateSelected.emit(formatDate(res, 'dd-MM-yyyy'));
        this.control.setValue(formatDate(res, 'dd MMMM yyyy'));
      }
    });
  }
 
}
